type MaskedTextProps = {
  value: string;
  mask: string;
};

export const mask = ({ value, mask }: MaskedTextProps) => {
  const applyMask = (text: string, mask: string): string => {
    let maskedText = '';
    let textIndex = 0;

    if (!text) return '';

    for (let i = 0; i < mask.length; i++) {
      if (mask[i] === '9' && textIndex < text.length) {
        maskedText += text[textIndex];
        textIndex++;
      } else if (textIndex >= text.length) {
        break;
      } else {
        maskedText += mask[i];
      }
    }

    return maskedText;
  };

  return applyMask(value, mask);
};

/**
 * Escolhe, entre várias máscaras (ex: telefone fixo vs celular), a que melhor encaixa
 * no tamanho do valor — a de menor quantidade de "9" que ainda comporta os dígitos.
 * Se nenhuma comportar, cai pra maior disponível (evita cortar o valor).
 */
export function applyBestMask(value: string, masks: string[]): string {
  if (!value || masks.length === 0) return value ?? '';

  const digits = value.replace(/\D/g, '');
  const withCounts = masks.map((m) => ({ mask: m, count: (m.match(/9/g) ?? []).length }));
  const fitting = withCounts
    .filter((m) => m.count >= digits.length)
    .sort((a, b) => a.count - b.count)[0];
  const chosen = fitting ?? withCounts.sort((a, b) => b.count - a.count)[0];

  return mask({ value: digits, mask: chosen!.mask });
}
